import React from "react";
import { CtaButton, CtaVideoButton } from "@components/shared/cta";

export default function ContentfulCta({ __typename, ...props }) {
  switch (__typename) {
    case "ContentfulCtaVideoModal":
      return <CtaVideoButton {...props} />;
    case "ContentfulCtaButton":
      return <CtaButton {...props} />;
    default:
      return null;
  }
}
